import { IImageUploaderImageListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//이미지 업로더 - 이미지 리스트 페이지: 테이블에 보여줄 리스트 데이터
async function getImageUploaderImageList(
  page: number
): Promise<AxiosResponse<FetchResult<IImageUploaderImageListItem[]>>> {
  const response = await instance.get(`/admin/images?page=${page}&take=15`);
  return response;
}

const useFetchImageUploaderImageList = (page: number) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/admin/images?page=${page}&take=15`],
    queryFn: () => getImageUploaderImageList(page),
    retry: false,
    refetchOnWindowFocus: false
  });

  const response = originalData?.data;

  return { response };
};

export default useFetchImageUploaderImageList;
